/**
 * @fileoverview Axios instance for the organization-admin portal (Spec 11).
 *
 * Same configuration as the instructor api.js but redirects to /org/login on
 * 401 instead of the landing page. A third auth surface alongside api.js
 * (instructor) and studentApi.js (student).
 */

import axios from "axios";

import BACKEND_URL from "./backendUrl";

const orgApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

orgApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      !window.location.pathname.startsWith("/org/login") &&
      !window.location.pathname.startsWith("/org/signup") &&
      !window.location.pathname.startsWith("/org/forgot-password") &&
      !window.location.pathname.startsWith("/org/reset-password")
    ) {
      window.location.href = "/org/login";
    }
    return Promise.reject(error);
  }
);

export default orgApi;

/**
 * Extract a human-readable error message from an Axios error (mirrors
 * api.js's getErrorMessage), handling structured `{code, message}` details.
 */
export function getOrgErrorMessage(error, fallback = "Something went wrong") {
  const detail = error.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg || d.message || JSON.stringify(d)).join(", ");
  if (typeof detail.message === "string") return detail.message;
  return fallback;
}
